import React from "react";
import { makeStyles } from "@mui/styles";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import PropTypes from "prop-types";
import Settings from "@mui/icons-material/Settings";
import ListItem from "@mui/material/ListItem";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(theme => ({
  listItem: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 8,
    paddingRight: 8,
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  listIcon: {
    minWidth: 0,
    marginRight: 8,
    color: theme.palette.component.headerColor,
    marginTop: 2,
    "& svg": {
      width: 15,
      height: 15,
    },
  },
  listText: {
    "& span": {
      color: theme.palette.component.headerColor,
      fontSize: 12,
    },
  },
}));

const AccountSettingsMenuItem = ({ handleOpenSettings }) => {
  const classes = useStyles();

  return (
    <ListItem button className={classes.listItem} onClick={handleOpenSettings}>
      <ListItemIcon className={classes.listIcon}>
        <Settings />
      </ListItemIcon>
      <FormattedMessage id="account.settings">
        {text => <ListItemText className={classes.listText} primary={text} />}
      </FormattedMessage>
    </ListItem>
  );
};

AccountSettingsMenuItem.propTypes = {
  handleOpenSettings: PropTypes.func.isRequired,
};

export default AccountSettingsMenuItem;
